import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import Message from 'app/utils/Message';
import Toast from 'app/utils/Toast';
import { adduser, getuserById, updateuser } from 'app/api/users';
import {
  userValidationRules,
  validate,
} from 'app/constants/validation-constants';

const useCreateUser = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [pageLoading, setPageLoading] = useState(false);
  const [error, setErrors] = useState({});
  const [editted, seteditted] = useState(false);
  const [values, setValues] = useState({
    phone: null,
    email: '',
    name: '',
    status: true,
  });

  const userId = location?.state?.id ? location?.state?.id : '';

  useEffect(() => {
    loadStoreData(userId);
  }, []);

  const loadStoreData = async () => {
    if (!userId) {
      return;
    }
    setPageLoading(true);
    let response = await getuserById(userId);
    setPageLoading(false);
    if (response?.responseCode === 200) {
      let responsedata = response?.data;
      setValues((prevState) => ({
        name: responsedata?.name,
        email: responsedata?.email,
        phone: responsedata?.phone,
        status: responsedata?.status,
      }));
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  };

  const callAddOrUpdateAPI = async () => {
    if (userId && !editted) {
      let data = { id: userId };
      handlePermision(data);
      return;
    }
    let response = {};
    if (userId) {
      response = await updateuser(userId, { ...values });
    } else {
      response = await adduser({ ...values });
    }
    setPageLoading(false);
    if (response?.responseCode === 200 && response?.data.createdUser?.id) {
      Toast.success(
        userId ? Message.User.UPDATED_SUCCESS : Message.User.CREATED_SUCCESS
      );
      handlePermision(response?.data?.createdUser);
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  };

  function handleCreateBill(e) {
    e.preventDefault();
    const validationErrors = validate(values, userValidationRules);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      callAddOrUpdateAPI();
    }
  }

  function handleChange(e) {
    if (userId) {
      seteditted(true);
    }

    if (e && e.target) {
      const { name, value } = e.target;
      setValues((prevValues) => ({
        ...prevValues,
        [name]: name === 'phone' ? parseInt(value) : value,
      }));

      if (error[name]) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: '',
        }));
      }
    }
  }

  function setChange(name, val) {
    if (userId) {
      seteditted(true);
    }
    setValues((prevState) => ({
      ...prevState,
      [name]: val,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '',
    }));
  }

  function handlePermision(data) {
    navigate(`/user/permission/:${data?.id}`, {
      state: {
        ...data,
      },
    });
  }

  return {
    userId,
    setChange,
    handleChange,
    values,
    error,
    handleCreateBill,
    pageLoading,
    navigate,
    editted,
  };
};

export default useCreateUser;
